import React from "react";
import hydro from "../../images/hy_icon.png";

const Logo = ({ height = 48, width = 48 }) => {
  return <img src={hydro} width={width} height={height} alt="Paywater logo" />;
};

export default Logo;
